import { apiClient } from "../../../lib/apiClient";
import type { ApiResponse } from "../../../types/apiResponse";
import type { CompanyLogo } from "../types";

export const deleteCompanyLogo = () => {
  return apiClient<ApiResponse<CompanyLogo>>("/v1/empresa/logo", {
    method: "DELETE",
  });
};
